import { fadeInit, fadeEnter, fadeLeave } from './fade';
import { logoInit, logoEnter, logoLeave } from './logo';
import { roundedButtonInit, roundedButtonEnter, roundedButtonLeave } from './roundedButton';
import { circularButtonInit, circularButtonEnter, circularButtonLeave } from './circularButton';
import { sliderInit, sliderEnter, sliderLeave } from './slider';

const initials = new Map();
const enter = new Map();
const leave = new Map();

initials.set('fade', fadeInit);
initials.set('logo', logoInit);
initials.set('roundedButton', roundedButtonInit);
initials.set('circularButton', circularButtonInit);
initials.set('slider', sliderInit);

enter.set('fade', fadeEnter);
enter.set('logo', logoEnter);
enter.set('roundedButton', roundedButtonEnter);
enter.set('circularButton', circularButtonEnter);
enter.set('slider', sliderEnter);

leave.set('fade', fadeLeave);
leave.set('logo', logoLeave);
leave.set('roundedButton', roundedButtonLeave);
leave.set('circularButton', circularButtonLeave);
leave.set('slider', sliderLeave);

export { initials, enter, leave };
